<div class="page-shell">
  <header class="page-header">
    <app-toolbar (onMenuIconClick)="sidenav.toggle()" [showPropertySearchByScroll]="showToolBarPropertiesSearchBox"></app-toolbar>
  </header>
  <main cdkScrollable class="page-wrapper">
    @if (businessId?.length>0) {
      <mat-sidenav-container class="flex-1">
        <mat-sidenav-content #sidenavContent class="flex-col justify-start items-stretch" [class]="hideScrollbar?'hideScrollbar':'showScrollbar'" cdkScrollable (scroll)="onScroll($event)">
          <div class="content">
            <router-outlet></router-outlet>
          </div>
          @if (showNewsletter) {
            <app-newsletter></app-newsletter>
          }
          @if (showFooter) {
            <app-footer class="footer"></app-footer>
          }
          @if (showBackToTop) {
            <div class="back-to-top flex-row justify-center items-center" (click)="scrollToTop()">
              <mat-icon>arrow_upward</mat-icon>
            </div>
          }
        </mat-sidenav-content>
        <mat-sidenav [opened]="false" mode="over" position="end" #sidenav class="sidenav mat-elevation-z6">
          <button mat-icon-button color="primary" (click)="sidenav.close()">
            <mat-icon color="primary">close</mat-icon>
          </button>
          <div class="divider"></div>
          <div class="vertical-menu-wrapper mt-2">
            <app-vertical-menu [menuParentId]="0" (routerLinkSelected)="closeSidenav()"></app-vertical-menu>
          </div>
          <div class="divider"></div>
        </mat-sidenav>
      </mat-sidenav-container>
    }
  </main>
</div>
@if (propertyImageArray) {
  <div class="swiper-overlay-wrapper" >
    <swiper-container #swiperRef navigation="true" rewind="true" slidesPerView="1" slidesPerGroup="1" (swiperslidechange)="onSwiperSlideChange($event)">
      @for (image of propertyImageArray; track image.id; let i = $index) {
        <swiper-slide>
          <img [src]="image.reference">
        </swiper-slide>
      }
    </swiper-container>
    <span class="image-count">{{slideIndex}} of {{propertyImageArray.length}}</span>
    <span class="close-button"><button mat-icon-button (click)="onSwiperCloseClick()"><mat-icon>clear</mat-icon></button></span>
  </div>
}
